/*
  Список докторов и выбор участвующих
*/

import './Manipulation.css';
import '../css/Main.css';
import React , { useState, useEffect, useContext } from 'react'
import axios_sender from '../modules/axios_sender.js'
import unique from '../modules/unique.js'
import {GetIDWarehouse} from '../modules/workers.js'

import {ThemeContext} from "../ThemeContext.js";

const Manipulation = (props) => {

//function Manipulation(props) {


  const [list_manipulation_type, SetListManipulationType] = useState([]);                     // список типов манипуляций

  const [button_article_service, SetButtonArticleService] = useState("К товарам");            // Надпись на кнопке



  //const { contextValue, setValue } = useContext(ThemeContext);
  const { valueContext, setValueContext } = useContext(ThemeContext);
  
  console.log(valueContext);


  useEffect(() => {
    LoadManipulationTypes();
  }, []);

  return (
    <>
    <div className="page-caption">СОЗДАНИЕ КАРТЫ ДЕЙСТВИЙ</div>
      <div className="container-fluid">
        
        <div className="row">
          <div className="select_article_service col" onClick={ ClickChangeArticlesServices }>{ button_article_service }</div>
          { list_manipulation_type }
        </div>              
      </div>
    </>
  );

  

  // загрузка типов манипуляций из БД. Услуги
  async function LoadManipulationTypes() { axios_sender({form: 'get_manipulation_types'}, LoadManipulationTypesSuccess); }
  function LoadManipulationTypesSuccess(data)
  {
      let list_mp = [];
      for(var i in data)
          if(data[i].cnt > 0)
          {
              let man = data[i];
              list_mp.push(
                <div key={ unique()} className='one-manipulation-types col' onClick={() => SelectedServiceType(man.ID) }>
                  { man.name }
                </div>
              );
          }
      SetListManipulationType(list_mp);
  }

  // загрузка типов манипуляций из БД. Товары
  async function LoadArticleTypes() { axios_sender({form: 'get_articles_types'}, LoadArticleTypesSuccess); }
  function LoadArticleTypesSuccess(data)
  {
      let list_mp = [];
      for(var i in data)
          if(data[i].cnt > 0)
          {
              let at = data[i];
              list_mp.push(
                <div key={ unique()} className='one-article-types col' onClick={() => SelectedArticleType(at.ID) }>
                  { at.name }
                </div>
              );
          }
      SetListManipulationType(list_mp);
  }




  // пользователь нажал на какой-то тип услуг. Покажем ему их
  function SelectedServiceType(id_service_type) { axios_sender({form: 'get_manipulation_type', id: id_service_type, ID_warehouse: GetIDWarehouse()}, SelectedServiceTypeSuccess); } 
  function SelectedServiceTypeSuccess(data)
  {
      // добавим список
      let list_mp = [];

      //вначале кнопку обратно
      list_mp.push(<div key={ unique() } className="button-back col" onClick={ () => LoadManipulationTypes()}></div>);

      for(var i in data)
      {
          let mp = data[i];
          mp.is_service = true;
          mp.qty = 1;          
          list_mp.push(
                <div key={ unique()} className='one-manipulation col row' onClick={() => ClickAddProduct(mp) }>
                  <div className="manipulation-name">{ mp.name }</div>
                  <div className="manipulation-price">{ mp.price }</div>
                </div>
              );
      }

      SetListManipulationType(list_mp);
  }

  // пользователь нажал на какой-то тип товаров. Покажем ему их
  function SelectedArticleType(ID_article) { axios_sender({form: 'get_article_type', id: ID_article, ID_warehouse: GetIDWarehouse()}, SelectedArticleTypeSuccess); } 
  function SelectedArticleTypeSuccess(data)
  {
      // добавим список
      let list_mp = [];

      //вначале кнопку обратно
      list_mp.push(<div key={ unique() } className="button-back col" onClick={ () => LoadArticleTypes()}></div>);

      for(var i in data)
      {
          let mp = data[i];
          mp.is_service = false;
          mp.qty = 1;

          list_mp.push(
                <div key={ unique()} className='one-manipulation col row' onClick={() => ClickAddProduct(mp) }>
                  <div className="manipulation-name">{ mp.name }</div>
                  <div className="manipulation-price">{ mp.price }</div>
                </div>
              );
      }

      SetListManipulationType(list_mp);
  }

  // пользователь добавляет услугу в список
  function ClickAddProduct(mp)
  {
      //props.AddManipulation(mp);

      var cntx = valueContext;
      if(cntx.mp_list === undefined || cntx.mp_list == null) cntx.mp_list = [];
      cntx.mp_list.push(mp);
      setValueContext(cntx);
  }
    

  // пользователь переключается между товарами и услугами
  function ClickChangeArticlesServices()
  {    
      if(button_article_service == "К товарам")
      {
          LoadArticleTypes();
          SetButtonArticleService("К услугам");
      }
      else
      {
          LoadManipulationTypes();
          SetButtonArticleService("К товарам");
      }
  }


};

export default Manipulation;
